const isEmpty = (string) => (!string || string.length === 0)

const maxLength = (string, length) => {
  if (isEmpty(string)) return true
  if (Number.isNaN(length)) return false
  return (string.length <= length)
}

module.exports = { maxLength }
